import AuthLogin from './Login.container';

export default AuthLogin;
